import React from 'react';
import InputAdornment from '@material-ui/core/InputAdornment';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles({
  root: {
    fontSize: 'inherit',
  },
});

interface Props {
  position?: 'start' | 'end';
  className?: string;
  inputRef?: React.Ref<any>;
}

const Adornment: React.FC<Props> = ({ children, position = 'end', className, inputRef }) => {
  const classes = useStyles();

  return (
    <InputAdornment
      disableTypography
      position={position}
      className={className}
      classes={{ root: classes.root }}
      ref={inputRef}
    >
      {children}
    </InputAdornment>
  );
};

export default Adornment;
